import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { withCurrentUser } from '~/hocs/withCurrentUser';
import { withUsers } from '~/hocs/withUsers';

import { getUserName } from '../../utils/user';

function UserName({
  userId,
  // injected
  users,
  currentUser,
}) {
  const intl = useIntl();
  const user = users[userId] || null;
  const userName = getUserName(user, intl);
  return currentUser && currentUser.id === userId
    ? intl.formatMessage(
        {
          id: 'UserName.currentUser',
          defaultMessage: '{userName} (You)',
          description:
            'Label for the current user in user name display. Example: userName = "John Smith"',
        },
        {
          userName,
        },
      )
    : userName;
}

UserName.propTypes = {
  // TODO: enforce all userIds to be string-type in the future
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default withUsers(withCurrentUser(UserName));
